@if (info) {
  <div
    class="w-full flex flex-col-reverse md:flex-row justify-between items-center md:items-center bg-ui-card rounded-base border border-ui-separator {{
      extraClass
    }}"
  >
    <div class="flex-1 md:p-xl p-lg flex flex-col text-text text-base leading-base">
      <div #titleSlot>
        <ng-content select="[slot=title]"></ng-content>
      </div>
      @if (!titleSlot.children.length) {
        <span>{{ info.title }}</span>
      }
      @if (info.subTitle) {
        <span>
          {{ info.subTitle }}
        </span>
      }
      @if (variant === 'shopNotVerified') {
        <div class="mt-lg w-full md:w-max">
          <mg-button class="w-full" size="small" type="button" routerLink="/shops">
            Add more shops
          </mg-button>
        </div>
      }
    </div>
    @if (info.imageKey) {
      <div class="flex justify-end pt-2xl pb-xs md:py-base px-xl md:pr-2xl">
        <mg-dynamic-images
          [style.height.px]="info.imageHeight ?? 150"
          class="w-fit"
          [key]="info.imageKey"
        ></mg-dynamic-images>
      </div>
    }
  </div>
}
